// kVA → amperes at the service voltage. The same phase selection
// serviceConfig.ts uses for the capacity direction, so display amps and
// capacity math cannot disagree.
export function kvaToAmps(
  kva: number,
  volts: number,
  phase: 'single' | 'three'
): number {
  if (!(volts > 0)) return 0;
  const divisor = phase === 'three' ? volts * Math.sqrt(3) : volts;
  return (kva * 1000) / divisor;
}
